import request from '@/utils/request'

// 查询用户标准路径列表
export function listStandardTemplateUser(query) {
    return request({
        url: '/biz/standardTemplateUser/list',
        method: 'get',
        params: query
    })
}

// 查询用户标准路径详细
export function getStandardTemplateUser(id) {
    return request({
        url: '/biz/standardTemplateUser/' + id,
        method: 'get'
    })
}

// 新增用户标准路径
export function addStandardTemplateUser(data) {
    return request({
        url: '/biz/standardTemplateUser',
        method: 'post',
        data: data
    })
}

// 修改用户标准路径
export function updateStandardTemplateUser(data) {
    return request({
        url: '/biz/standardTemplateUser/update',
        method: 'post',
        data: data
    })
}

// 删除用户标准路径
export function delStandardTemplateUser(id) {
    return request({
        url: '/biz/standardTemplateUser/delete/' + id,
        method: 'post'
    })
}
